export default "__VITE_ASSET__DNZl6Qcx__"